import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { ProfileSection, PasswordSection, BrandSection, PermissionsMatrix } from "@/components/SettingsSections";
import { CategoriasManager } from "@/components/CategoriasManager";
import { AniversarioSection } from "@/components/AniversarioSection";

export default function Settings() {
  const { user } = useAuth();
  const isAdmin = user.role === "admin";
  return (
    <div data-testid="settings-page">
      <PageHeader eyebrow="Conta" title="Configurações" subtitle="Seus dados de acesso e, para administradores, a identidade do aplicativo." />
      <div className="grid lg:grid-cols-2 gap-5">
        <ProfileSection />
        <PasswordSection />
        {isAdmin && <BrandSection />}
        {isAdmin && <AniversarioSection />}
        {isAdmin && <CategoriasManager />}
        {isAdmin && <PermissionsMatrix />}
      </div>
    </div>
  );
}
